import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { BlenderJob } from '../../admin/models/blender-job.model';

@Injectable()
export class BlenderJobService {
  constructor(private http: HttpClient) {}
  /**
   * Get all blender jobs
   */
  getBlenderJobsForAdmin(filter: object) {
    const url = `${environment.apiConfig.url}/admin/blender-jobs?filter=${JSON.stringify(filter)}`;
    return this.http.get<BlenderJob[]>(url);
  }
}
